import * as moment from 'moment';

import { parseDateForDisplay } from '../../../Utils/Parsers/timeParsers';

const NORMALIZE_DISPLAY_FIELDS = [
    {
        key: 'DueDate',
        label: 'Data Vencimento',
        normalizer: value => parseDateForDisplay(value, [moment.HTML5_FMT.DATETIME_LOCAL_SECONDS]),
    },
];

export const normalizeTermsAsset = incomingAsset => {
    const normalizedObj = { ...incomingAsset, normalized: {} };

    NORMALIZE_DISPLAY_FIELDS.forEach(field => {
        const normalizedField = {
            label: field.label,
            rawValue: normalizedObj[field.key],
            value: field.normalizer(normalizedObj[field.key]),
        };

        normalizedObj.normalized = { ...normalizedObj.normalized, [field.key]: normalizedField };
    });

    return normalizedObj;
};

export default normalizeTermsAsset;
